import produce from 'immer'
import { format, Locale, formatISO, parse, parseISO } from 'date-fns'
import { es, enUS } from 'date-fns/locale'

export interface IDateObject {
  day?: number;
  month: number;
  year: number;
}

interface IDateNewObject{
  day: number;
  month: number;
  year: number;
}

export const formatToDateString = (dateObject: IDateObject) => {
  const newDateObject = produce(dateObject, draftState => {
    if (!('day' in draftState)) {
      draftState.day = 1
    }
  }) as IDateNewObject

  const result = formatISO(new Date(newDateObject.year, newDateObject.month - 1, newDateObject.day), { representation: 'date' })
  return result
}

export const getFormalDate = (date: string|Date, lang: string) => {
  const locale: Locale = lang === 'en' ? enUS : es
  const formalDate = format(new Date(date), 'MMMM dd, yyyy', { locale: locale })

  // Spanish month values come back lowercase because they are supposed to be displayed second
  // but we are displaying Spanish month names in the English date format, so they need to be capitalized
  return formalDate.charAt(0).toUpperCase() + formalDate.slice(1)
}

export class DateUtil {
  private static readonly __SERVER_TZ: string = ''

  private __isoString: string

  public static fromISO (isoString: string) {
    return new DateUtil(isoString)
  }

  public static fromFormattedString (dateString: string, format: string) {
    const iso = parse(dateString, format, new Date()).toISOString()

    return new DateUtil(iso)
  }

  constructor (isoString: string) {
    this.__isoString = isoString
  }

  public toServerDateString (formatString: string = 'M/d/yyyy', lang: string = 'en') {
    const locale: Locale = lang === 'en' ? enUS : es

    // TODO: This will need to be reevaluated. Parsing timezones is difficult with date-fns
    // so may need to look at an alternative. Currently the functionality of this is identical to
    // toLocalDateString
    return format(parseISO(this.__isoString), formatString, { locale })
  }

  public toLocalDateString (formatString: string = 'M/d/yyyy', lang: string = 'en') {
    const locale: Locale = lang === 'en' ? enUS : es

    return format(parseISO(this.__isoString), formatString, { locale })
  }
}
